import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'

export class RemoveRmaLineUpload extends RmaRequest<void, never> {
  path: string
  override init: RequestInit = { method: 'DELETE' }

  constructor({ lineId, identifier }: { lineId: string, identifier: string }) {
    super()
    this.path = `account/rma/draft/upload/${lineId}/${identifier}/`
  }

  override parseResponse = (data: unknown) => data as string
}
